import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import actions from '../../components/OrganizationSetup/Components/Actions/Actions';

const initialState = {
    currentStep : 1,
    file: '',
    fileName:'',
    allColumns : [],
    matchedColumn : '',
    officeHierarchy : [],
    manageNewOffices:[],
    allOffices : [],
    disabledOffices:[],
    selectedFlaggedAdminOffice : null,
    allOfficesWithInvitations : [],
    adminPerOffice : {},
    allOfficeMaterialPaths : [],
    rowData : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.ORG_CHART_NEXT_STEP: 
          return {...state,currentStep : state.currentStep + 1};
        case actionTypes.ORG_CHART_PREVIOUS_STEP :
          return {...state,currentStep : state.currentStep - 1};  
        case actionTypes.ORG_CHART_STORE_ALL_COLUMNS_AND_DATA:
          return {...state, allColumns : action.val.columns, rowData : action.val.data, file: action.val.file, fileName: action.val.file.name};
        case actionTypes.ORG_CHART_STORE_MATCHED_COLUMN :
          return {...state, matchedColumn : action.val};
        case actionTypes.ORG_CHART_SELF_OFFICE_SELECTED :
          return {...state,selfOffice : action.val};
        case actionTypes.ORG_CHART_STORE_ALL_OFFICES : 
          return {...state,allOffices : action.val};
        



        case actionTypes.MANAGE_NEW_OFFICES :
          return {...state, manageNewOffices: action.val };  

          case actionTypes.SAVE_HIERARCHY_CHANGES :
            return {...state, temporaryHierarchy: action.val};  

          case actionTypes.SAVE_UPDATED_OFFICES :
            return {...state, updatedOffices: action.val };  


          case actionTypes.SAVE_DISABLED_OFFICES :
              return {...state, disabledOffices: action.val };  


         case actionTypes.ORG_CHART_STORE_OFFICE_HIERARCHY :
           console.log(action, action.val)
          return {...state, officeHierarchy:action.val}


        case actionTypes.ORG_CHART_STORE_MATERIAL_PATHS :
          return {...state,allOfficeMaterialPaths : action.val};
        case actionTypes.ORG_CHART_FLAGGED_ADMIN_OFFICE_SELECTED :
          return {...state,selectedFlaggedAdminOffice:action.val};
        case actionTypes.ORG_CHART_STORE_MATERIAL_PATHS_WITH_INVITATION :
          return {...state,allOfficesWithInvitations : action.val};
          default:
          break;
    }
    return state;
}